import React from "react";
import appConfig from "@/config/appConfig";

const AuthFooter = () => {
  return (
    <div className="footer" style={{ background: "#000", color: "#fff" }}>
      <div className="container-fluid w-100 ">
        <div className="row">
          <div className="col w-100">
            <p className="my-2 text-center" style={{ fontSize: "14px" }}>
              <span>{appConfig.copyright}</span>
              <span className="footer-policy">
                <a href="https://ivistech.com/term-of-use" rel="noreferrer" target={"_blank"} className="footer_link">
                  Terms of Use
                </a>{" "}
                |{" "}
                <a
                  href="https://ivistech.com/privacy-policy"
                  rel="noreferrer"
                  target={"_blank"}
                  className="footer_link"
                >
                  Privacy Policy
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthFooter;
